export default "__VITE_ASSET__DX19E$3O__"